import React from "react";
import "./NotAllowed.css";
import notAllowed from "../assets/img/notAllowed.jpeg"

function NotAllowed() {
  return (
    <>
      <section className="page_404">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 ">
              <div className="col-sm-10 col-sm-offset-1  text-center">
                <div className="four_zero_four_bg">
                <img src={notAllowed} alt="" />
                </div>
                <div className="contant_box_404">
                  <h2 className="h2_tag">We are sorry...</h2>
                  <h4 className="notFound__text">
                    But you are not authorised to visit here.
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default NotAllowed;
